module.exports = __webpack_public_path__ + "assets/img/63a9906a04853b23ba76878f9a57b918.svg";